import { EnvironmentName } from './shared/types/enums/environmentName';

export const getEnvironmentName = (env?: string): EnvironmentName => {
  const url = new URL(env || document.baseURI);
  if (url.hostname === 'localhost') return 'local';
  if (url.hostname === 'mango-pebble-03468b803.1.azurestaticapps.net' && url.protocol === 'https:') return 'dev';
  if (url.hostname === 'maskin-test.tsmaskin.no' && url.protocol === 'https:') return 'test';
  if (url.hostname === 'maskin.tsmaskin.no' && url.protocol === 'https:') return 'prod';
  return '';
};
